import { render, staticRenderFns } from "./CompetencesList.vue?vue&type=template&id=7f4cf2fc&scoped=true&"
import script from "./CompetencesList.vue?vue&type=script&lang=js&"
export * from "./CompetencesList.vue?vue&type=script&lang=js&"
import style0 from "./CompetencesList.vue?vue&type=style&index=0&id=7f4cf2fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4cf2fc",
  null
  
)

export default component.exports